import { render, staticRenderFns } from "./EventModal.vue?vue&type=template&id=1abb9bae&scoped=true"
import script from "./EventModal.vue?vue&type=script&lang=js"
export * from "./EventModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abb9bae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1abb9bae')) {
      api.createRecord('1abb9bae', component.options)
    } else {
      api.reload('1abb9bae', component.options)
    }
    module.hot.accept("./EventModal.vue?vue&type=template&id=1abb9bae&scoped=true", function () {
      api.rerender('1abb9bae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Events/EventModal.vue"
export default component.exports